(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ag-countdown-timer')) {
    class AgCountdownTimer extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.clientStartedAt = Date.now();
        this.serverStartedAt = Number(this.dataset.serverNow) * 1000;
        this.clockOffset = Number.isFinite(this.serverStartedAt)
          ? this.serverStartedAt - this.clientStartedAt
          : 0;
        this.duration = this.getDuration();
        this.targetTime = this.getTargetTime();
        this.handleVisibilityChange = () => {
          if (!document.hidden) this.update();
        };

        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if (!Number.isFinite(this.targetTime)) {
          this.showMessage('Set a valid countdown deadline in the Theme Editor.');
          return;
        }

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      getNow() {
        return Date.now() + this.clockOffset;
      }

      getDuration() {
        const days = Math.max(0, Number.parseInt(this.dataset.durationDays, 10) || 0);
        const hours = Math.max(0, Number.parseInt(this.dataset.durationHours, 10) || 0);
        const minutes = Math.max(0, Number.parseInt(this.dataset.durationMinutes, 10) || 0);

        return ((days * 24 + hours) * 60 + minutes) * 60 * 1000;
      }

      getTargetTime() {
        const now = this.getNow();
        const storedTarget = this.readStoredTarget();

        if (this.dataset.mode === 'evergreen') {
          if (Number.isFinite(storedTarget)) return storedTarget;

          const evergreenTarget = now + this.duration;
          if (this.dataset.persist === 'true') this.writeStoredTarget(evergreenTarget);
          return evergreenTarget;
        }

        const fixedTarget = Date.parse(this.dataset.deadline);

        if (
          this.dataset.expiryAction === 'restart' &&
          Number.isFinite(fixedTarget) &&
          fixedTarget <= now &&
          Number.isFinite(storedTarget)
        ) {
          return storedTarget;
        }

        return fixedTarget;
      }

      readStoredTarget() {
        if (this.dataset.persist !== 'true' && this.dataset.expiryAction !== 'restart') {
          return Number.NaN;
        }

        try {
          const value = Number.parseInt(localStorage.getItem(this.dataset.storageKey), 10);
          return Number.isFinite(value) ? value : Number.NaN;
        } catch (error) {
          return Number.NaN;
        }
      }

      writeStoredTarget(target) {
        try {
          localStorage.setItem(this.dataset.storageKey, String(target));
        } catch (error) {
          // Storage unavailable হলে countdown current page session-এ চলতে থাকবে।
        }
      }

      update() {
        const remaining = this.targetTime - this.getNow();

        if (remaining <= 0) {
          this.handleExpiry();
          return;
        }

        const showSeconds = this.dataset.showSeconds === 'true';
        const showDays = this.dataset.showDays === 'true';
        const displayRemaining = showSeconds
          ? remaining
          : Math.ceil(remaining / 60000) * 60000;
        const totalSeconds = Math.max(0, Math.floor(displayRemaining / 1000));
        const days = Math.floor(totalSeconds / 86400);
        const hours = showDays
          ? Math.floor((totalSeconds % 86400) / 3600)
          : Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.setNumber('[data-countdown-days]', days);
        this.setNumber('[data-countdown-hours]', hours);
        this.setNumber('[data-countdown-minutes]', minutes);
        this.setNumber('[data-countdown-seconds]', seconds);
        this.updateAccessibleText({ days, hours, minutes, seconds, showDays, showSeconds });
      }

      setNumber(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = String(value).padStart(2, '0');
      }

      updateAccessibleText({ days, hours, minutes, seconds, showDays, showSeconds }) {
        const accessible = this.querySelector('[data-countdown-accessible]');
        if (!accessible) return;

        const minuteKey = `${days}-${hours}-${minutes}`;
        if (this.lastAnnouncedMinute === minuteKey) return;

        this.lastAnnouncedMinute = minuteKey;
        const parts = [];
        if (showDays) parts.push(`${days} days`);
        parts.push(`${hours} hours`, `${minutes} minutes`);
        if (showSeconds) parts.push(`${seconds} seconds`);
        accessible.textContent = `${parts.join(', ')} remaining`;
      }

      handleExpiry() {
        const action = this.dataset.expiryAction;

        if (action === 'restart' && this.duration > 0) {
          this.targetTime = this.getNow() + this.duration;
          this.writeStoredTarget(this.targetTime);
          this.update();
          return;
        }

        window.clearInterval(this.interval);

        if (action === 'hide') {
          this.hidden = true;
          return;
        }

        this.showMessage(this.dataset.expiredMessage);
      }

      showMessage(message) {
        const grid = this.querySelector('[data-countdown-grid]');
        const expired = this.querySelector('[data-countdown-expired]');

        if (grid) grid.hidden = true;
        if (expired) {
          expired.textContent = message;
          expired.hidden = false;
        }
      }
    }

    customElements.define('ag-countdown-timer', AgCountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
